<template>
    <div>
        slide
    </div>
</template>

<script>
import ctrl from "./singleProduct.js";
export default ctrl;
</script>